import { BaseWidgetFormFields } from 'components/consumer-page-widgets/BaseWidgetFormFields';
import { Button, Typography } from 'ui';
import {
  ButtonArrayWidgetFields,
  ButtonArrayWidgetFormFields,
} from 'components/consumer-page-widgets/button-array-widget/ButtonArrayWidgetFormFields';
import { Form, Formik } from 'formik';
import { Widgets } from '@tock/shared/types/widget';
import {
  getBaseFormFieldsInitialValues,
  useCreateNamedConfigurations,
} from 'components/consumer-page-widgets/widgetFormUtils';
import {
  widgetFormButtonContainer,
  widgetFormRoot,
} from 'components/consumer-page-widgets/widgetFormCssDefs';
import React, { FunctionComponent } from 'react';

interface CreateButtonArrayWidgetFormProps {
  onCompleteOrCancel(): void;
}

export const CreateButtonArrayWidgetForm: FunctionComponent<
  React.PropsWithChildren<CreateButtonArrayWidgetFormProps>
> = ({ onCompleteOrCancel }) => {
  const createNamedConfig = useCreateNamedConfigurations();

  const handleSubmit = ({
    buttonCountLimit,
    buttonCountLimitDesktop,
    aggregationCountMinimum,
    tagType,
    heading,
    name,
    includeVerticalSpacing,
  }: ButtonArrayWidgetFields) => {
    return createNamedConfig({
      name: name,
      widgetType: Widgets.WidgetCreatorWidgetType,
      buttonArrayWidgetConfig: {
        buttonCountLimit,
        buttonCountLimitDesktop,
        aggregationCountMinimum,
        heading,
        tagType,
        includeVerticalSpacing,
      },
    }).then(onCompleteOrCancel);
  };

  return (
    <>
      <Typography variant="heading1Bold">Create widget</Typography>
      <Formik<ButtonArrayWidgetFields>
        enableReinitialize
        initialValues={{
          ...getBaseFormFieldsInitialValues(),
          buttonCountLimit: 0,
          buttonCountLimitDesktop: 0,
          aggregationCountMinimum: 0,
          heading: '',
          tagType: 'WINE_FLAVOR',
          includeVerticalSpacing: true,
        }}
        onSubmit={handleSubmit}
      >
        <Form css={widgetFormRoot}>
          <BaseWidgetFormFields />
          <ButtonArrayWidgetFormFields />
          <div css={widgetFormButtonContainer}>
            <Button type="submit">Submit</Button>
            <Button variant="outlined" type="button" onClick={onCompleteOrCancel}>
              Cancel
            </Button>
          </div>
        </Form>
      </Formik>
    </>
  );
};
